import React from 'react'
import {Icon} from '@chakra-ui/react'

const EditIcon = (props) => {
    return (
        <Icon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="none"
            id="edit"
            {...props}
        >
            <path
                d="M11.8295 1.91602C12.4269 1.91609 13.0007 2.15377 13.4232 2.57617C13.8457 2.99873 14.0834 3.57242 14.0834 4.16992C14.0832 4.7673 13.8456 5.34024 13.4232 5.7627L12.3246 6.86035C12.3058 6.88447 12.2862 6.90848 12.264 6.93066C12.2417 6.953 12.218 6.97326 12.1937 6.99219L6.30408 12.8828H6.3031C6.14528 13.0401 5.96069 13.1669 5.75818 13.2568L5.54919 13.335L3.22791 14.0391H3.22595C3.05026 14.0918 2.86283 14.0965 2.68494 14.0518C2.50731 14.007 2.34489 13.9146 2.21521 13.7852C2.08559 13.6556 1.99264 13.4931 1.94763 13.3154C1.90272 13.1376 1.90684 12.9501 1.95935 12.7744L1.96033 12.7715L2.66443 10.4502L2.66541 10.4482C2.75274 10.1637 2.90876 9.90447 3.11951 9.69434L9.01208 3.7998C9.02968 3.7777 9.04925 3.75678 9.0697 3.73633C9.09015 3.71588 9.11108 3.6963 9.13318 3.67871L10.2367 2.57617C10.6592 2.15381 11.2321 1.91615 11.8295 1.91602ZM4.17908 10.7559L4.1781 10.7568C4.14147 10.7934 4.11421 10.8392 4.099 10.8887L3.65759 12.3408L5.11365 11.8994L5.18396 11.8682C5.20583 11.855 5.22629 11.8394 5.24451 11.8213L10.6674 6.39551L9.60291 5.33008L4.17908 10.7559ZM11.8295 3.41602C11.6299 3.41615 11.4384 3.49567 11.2972 3.63672L10.6635 4.26953L11.7289 5.33398L12.3617 4.70215H12.3627C12.5037 4.561 12.5832 4.36946 12.5834 4.16992C12.5833 3.97031 12.5038 3.77793 12.3627 3.63672C12.2214 3.49566 12.0291 3.41604 11.8295 3.41602Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EditIcon
